import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_8 = { class: "card-body pt-10" }
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_11 = { class: "my-5 px-8" }
const _hoisted_12 = { class: "row g-9 mb-8" }
const _hoisted_13 = { class: "col-md-8 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tên đại lý ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Đường dẫn ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Website ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Điện thoại ", -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tỉnh/Thành Phố", -1)
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Quận/Huyện", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Phường/Xã", -1)
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Đường", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Địa chỉ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt-fill fs-3" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tóm tắt nội dung")
], -1)
const _hoisted_35 = { class: "col-md-4 fv-row" }
const _hoisted_36 = { class: "d-flex justify-content-between fs-6 fw-bold" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "Hình ảnh", -1)
const _hoisted_38 = { class: "svg-icon svg-icon-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_40 = { class: "d-flex" }
const _hoisted_41 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_42 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_43 = ["src"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_agency_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.objectData.name), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.name))),
                          modelValue: _ctx.objectData.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.name) = $event)),
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.slug,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.slug) = $event)),
                          name: "slug"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.website,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.website) = $event)),
                          name: "website"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "phone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.phone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.phone) = $event)),
                          name: "website"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_el_form_item, { prop: "location.province_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.province_id,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objectData.location.province_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Tỉnh/Thành Phố",
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (
                            _ctx.onChangeLocation(_ctx.objectData.location.province_id)
                          )),
                              rules: [
                            {
                              required: true,
                              message: 'Please input email address',
                              trigger: 'blur',
                            },
                          ]
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataProvince, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_el_form_item, { prop: "location.district_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.district_id,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objectData.location.district_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Quận/Huyện",
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (
                            _ctx.onChangeDistrict(_ctx.objectData.location.district_id)
                          ))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataDistrict, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_el_form_item, { prop: "location.ward_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.ward_id,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectData.location.ward_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Phường/Xã",
                              onChange: _ctx.onChangeWard
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataWard, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_el_form_item, { prop: "location.street_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.street_id,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objectData.location.street_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Đường",
                              onChange: _ctx.onChangeStreet
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataStreet, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_28,
                      _createVNode(_component_el_form_item, { prop: "address" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.objectData.address,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objectData.address) = $event)),
                            placeholder: "Nhập vào địa chỉ"
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-sm",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.pinMap())),
                            style: {"position":"absolute","right":"4px","top":"2px"},
                            type: "button"
                          }, _hoisted_30)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_GoogleMap, {
                        ref: "mapRef",
                        "api-key": _ctx.map_api_key,
                        style: {"width":"100%","height":"450px"},
                        center: _ctx.centerMap,
                        zoom: 15,
                        onClick: _ctx.mark
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Marker, { options: _ctx.markerOptions }, null, 8, ["options"])
                        ]),
                        _: 1
                      }, 8, ["api-key", "center", "onClick"]),
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _createVNode(_component_el_form_item, { prop: "short_content" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: _ctx.objectData.content,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objectData.content) = $event)),
                            placeholder: "Mô tả ngắn gọn",
                            rows: "4",
                            name: "short_content"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showMultipleMedia('images'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_39
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.images, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-md-4"
                        }, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("img", {
                                class: "w-100",
                                style: {"object-fit":"cover","height":"150px"},
                                src: _ctx.renderImageUrl(img, 'medium'),
                                alt: ""
                              }, null, 8, _hoisted_43)
                            ]),
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              onClick: ($event: any) => (
                              _ctx.removeImages({ name: 'image', index: index })
                            )
                            }, _hoisted_46, 8, _hoisted_44)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _hoisted_47
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}